import type { HttpResourceRequest } from '@angular/common/http';
import { Service } from '@angular/core';
import { environment } from '@env/environment';
import { withAuth } from '@shared/utils/http-context.util';

@Service()
export class GenderClient {
  public buildGendersRequest(): HttpResourceRequest {
    return {
      url: `${environment.urlApiPlatform}gender`,
      method: 'GET',
      ...withAuth(),
    };
  }
}
